module.exports = __webpack_public_path__ + "img/pain1.svg";